<template>
  <div class="message-body">
    <div class="alert-message hide-popup" :class="[getMessageObj.type, getMessageObj.customClass]">
      <div class="alert-icon">
        <i class="icon fa fa-ban" v-if="getMessageObj.type === 'error'"></i>
        <i class="icon fa fa-warning" v-else-if="getMessageObj.type === 'warning'"></i>
        <i class="icon fa fa-check" v-else-if="getMessageObj.type === 'success'"></i>
      </div>
      <div class="text-message" :v-bind="autoClose()">{{titleMessage}} {{message}}
        <span class="yammer-url" v-if="getMessageObj.type === 'error'">, <a v-bind:href="yammerErrorUrl">Please click here to connect with yammer.</a></span>
      </div>
      <button type="button" class="close" @click="close()">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'Simplert',
  data () {
    return {
      getMessageObj: [],
      titleMessage: '',
      message: '',
      yammerErrorUrl: 'https://www.yammer.com/dentsuaegis.com/#/threads/inGroup?type=in_group&feedId=13299443&view=unviewed'
    }
  },
  methods: {
    open (obj) {
      console.log('Object Data : ', obj)
      var self = this
      if (obj.type === 'info') {
        self.close()
        self.$Simplert2.open(obj)
      } else {
        if (obj.onClose) {
          let callBack = obj.onClose
          callBack()
        }
        this.getMessageObj = obj
        if (obj.title) {
          let errorTitle = obj.title.toLowerCase()
          this.titleMessage =
            errorTitle.charAt(0).toUpperCase() + errorTitle.slice(1)
          console.log('this.titleMessage :: ', this.titleMessage)
        }

        if (obj.message) {
          let errorMessage = obj.message.toLowerCase()
          this.message =
            ',' +
            ' ' +
            errorMessage.charAt(0).toUpperCase() +
            errorMessage.slice(1)
          console.log('this.message :: ', this.message)
        }

        // self.$Simplert.close()
        $('body').addClass('show-popup')
        setTimeout(function () {
          $('.alert-message').removeClass('hide-popup')
        }, 1)
      }
    },
    close () {
      $('.alert-message').addClass('hide-popup')
      $('body').removeClass('show-popup')
    },
    autoClose () {
      setTimeout(function () {
        $('.alert-message').addClass('hide-popup')
        $('body').removeClass('show-popup')
      }, 6000)
    }
  }
}
</script>

<style scoped>
.alert-message {
  border-radius: 3px;
  color: #ffffff;
  font-size: 18px;
  padding: 10px;
  width: 89.2%;
  margin: 0 9.6%;
  display: inline-flex;
  top: 60px;
  position: absolute;
  transition: transform 0.3s ease-in-out, 0.3s ease-in-out;
}
.sidebar-collapse .alert-message {
  width: 96.2%;
  margin: 0 66px;
}
.warning {
  background-color: #f39c12;
  opacity: 0.8;
}
.error {
  background-color: rgb(221, 75, 57, 0.8) !important;
}
.success {
  background-color: #00a65a;
  opacity: 0.8;
}
.text-message {
  width: 100%;
  margin-left: 10px;
}
.close {
  color: white;
  font-size: 25px;
  opacity: 1;
  text-shadow: 1px 1px 2px #444;
}
.hide-popup {
  animation: hidepopup 1.4s ease-in-out both;
}
.yammer-url {
  margin: 0;
  cursor: pointer;
}
.yammer-url a {
  color: #ffffff;
  text-decoration: underline;
}
@keyframes hidepopup {
  0% {
    opacity: 1;
  }
  80% {
    opacity: 0;
  }
  100% {
    display: none;
    opacity: 0;
  }
}
@media only screen and (max-width: 1460px) {
  .alert-message {
    width: 79.8%;
    margin: 0 17.9%;
  }
  .sidebar-collapse .alert-message {
    width: 92.8%;
    margin: 0 65px;
  }
}
</style>

<style>
.show-popup .content-wrapper {
  padding-top: 60px;
}
</style>



// WEBPACK FOOTER //
// alert.vue?f5e96486